import { ThirdPartyConversationItem } from './thirdparty-conversation-item';

export class ThirdPartyFormConversations {
    thridPartyId: number = 0;
    thridPartyEvaluationFormId: number = 0;
    formConversations: ThirdPartyConversationItem[] = [];
    itemsConversations: ThirdPartyConversationItem[] = [];

    constructor() {        
    }
}
